'use strict';

$(function () {

    var basketTimeout = null,
        defaultTimeout = 500,
        $basketItemQtyElements = $('.basket-item-quantity'),
        $basketItemRemoveBtn = $('.aganjs-basket-item-remove-btn');

    /**
     * @param {int} value Overwrites default timeout
     */
    function submitBasketForm(value) {
        var timeout = value || defaultTimeout;

        if (basketTimeout === null) {
            basketTimeout = window.setTimeout(function () {
                $('#basket_form').submit();
                basketTimeout = null;
            }, timeout);
        }
    }

    /**
     * @param {int} value ID that identifies the product in Basket
     */
    function removeBasketItem(basketID) {
        $('input[data-basket-id=aproducts_' + basketID + '_remove]').val(1);
        $('input[name=aganRemoveBasketItem]').val(1);
        submitBasketForm(250);
    }

    /**
     * BasketItem Quantity Handling
     */
    if ($basketItemQtyElements.length > 0) {
        $basketItemQtyElements.each(function () {

            var $input = $($(this).find('input'));
            var $plus = $($(this).find('.btn-plus'));
            var $minus = $($(this).find('.btn-minus'));

            $plus.click(function () {
                var qty = parseInt($input.val());

                if (qty < parseInt($input.data('qty-max'))) {
                    qty++;
                    $input.val(qty);

                    submitBasketForm();
                }
            });

            $minus.click(function () {
                var qty = parseInt($input.val());

                if (qty > 1) {
                    qty--;
                    $input.val(qty);

                    submitBasketForm();
                } else {
                    removeBasketItem($(this).data('basket-id'));
                }
            });

            $input.change(function () {
                var qty = parseInt($input.val());

                if (qty === 0) {
                    $input.val(1);
                } else if (qty > parseInt($input.data('qty-max'))) {
                    $input.val($input.data('qty-max'));
                } else {
                    $input.val(qty);
                }

                submitBasketForm();
            });

        });
    }

    /**
     * BasketItem Remove Handling
     */
    if ($basketItemRemoveBtn.length > 0) {
        $basketItemRemoveBtn.each(function () {
            var $this = $(this);

            $this.click(function () {
                removeBasketItem($this.data('basket-id'));
            });
        });
    }
});
